import { get } from '../utils/axios'

export const getNationalitysAPI = async () => {
  return await get('nationalitys')
}
